import React, { FC, useState } from "react";
import { Col, Input, Row } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import { ErrorServices, useCreateJobFunctionMutation } from "@/services";
import Button from "@/components/Button";

const AddJobFunction: FC<IModal> = ({ isVisible, setIsVisible }) => {
  const [jobFunction, setJobFunction] = useState("");
  const [creatJobFunction, { isLoading }] = useCreateJobFunctionMutation();

  const onSubmit = async () => {
    try {
      await creatJobFunction({ name: jobFunction }).unwrap();
      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setJobFunction(e.target.value);
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobFunction("");
  };

  return (
    <Modal
      width={544}
      onClose={closeModal}
      footer={[
        <Button
          key="1"
          variant="buttonCore"
          disabled={!jobFunction || isLoading}
          onClick={onSubmit}
          isLoading={isLoading}
          className="w-56"
        >
          Add
        </Button>,

        <Button
          key="2"
          variant="buttonBlue"
          onClick={closeModal}
          className="w-28"
        >
          Cancel
        </Button>,
      ]}
      title="Add a Job Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job Function</label>
            <Input
              value={jobFunction}
              onChange={handleInput}
              size="large"
              placeholder="Name of the job function here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default AddJobFunction;
